/** Routes to scenes (docs/spec/04 §6): the game is the app's; every menu is the UI's. */

import type { Scene, SceneFactory } from '../ui/scene';
import { createUiScene } from '../ui/scenes';
import type { GameDeps } from './game/gameScene';
import { GameScene } from './game/gameScene';

export function createFactory(game: GameDeps): SceneFactory {
  return (route, host): Scene => {
    if (route.to === 'play') return new GameScene(host, route.request, game);
    return createUiScene(route, host);
  };
}
